import { initialState } from "./localityInitialState";
import { TYPES } from "./localityTypes";

export function LocalityReducer(state, action) {
  const { type, payload } = action;

  const setToggleModalOpen = () => {
    return {
      ...state,
      isModalOpen: !state.isModalOpen,
      type: payload?.type || null,
      selectedIdToEdit: payload?.selectedIdToEdit || null,
    };
  };

  const setFieldIsFictious = () => {
    return {
      ...state,
      fields: {
        ...state.fields,
        [payload]: {
          ...state.fields[payload],
          isFictional: !state.fields[payload].isFictional,
        },
      },
    };
  };

  const setField = () => {
    return {
      ...state,
      fields: {
        ...state.fields,
        [payload.field]: {
          ...state.fields[payload.field],
          ...payload,
        },
      },
    };
  };

  const setClearFieldAndItsChildren = () => {
    const clearField = (key) => {
      return {
        id: null,
        isFictional: false,
        field: key,
        label: key,
      };
    };

    function getKeysFrom(obj, fromKey, orderedKeys) {
      const startIndex = orderedKeys.indexOf(fromKey);
      if (startIndex === -1) return {};

      const keysToKeep = orderedKeys.slice(startIndex);
      return Object.fromEntries(
        keysToKeep
          .filter((key) => key in obj)
          .map((key) => [key, clearField(key)])
      );
    }

    const clearedChildren = getKeysFrom(
      state.fields,
      payload.field,
      Object.keys(state.fields)
    );

    return {
      ...state,
      fields: {
        ...state.fields,
        ...clearedChildren,
      },
    };
  };

  const setClearFormData = () => {
    return {
      ...state,
      fields: initialState.fields,
    };
  };

  const setRequestedLocalitiesData = () => {
    return {
      ...state,
      localities: payload,
    };
  };

  const setLastForm = () => {
    return {
      ...state,
      lastForm: payload,
    };
  };

  const setLastCreation = () => {
    return {
      ...state,
      lastCreation: payload,
    };
  };

  const setStateReducerTypes = {
    [TYPES.SET_TOGGLE_MODAL_OPEN]: setToggleModalOpen,
    [TYPES.SET_FIELD_IS_FICTIOUS]: setFieldIsFictious,
    [TYPES.SET_FIELD]: setField,
    [TYPES.SET_CLEAR_FIELD_AND_CLEAR_CHILDREN]: setClearFieldAndItsChildren,
    [TYPES.SET_CLEAR_FORM_DATA]: setClearFormData,
    [TYPES.SET_REQUESTED_LOCALITIES_DATA]: setRequestedLocalitiesData,
    [TYPES.SET_LAST_FORM]: setLastForm,
    [TYPES.SET_LAST_CREATION]: setLastCreation,
  };

  return setStateReducerTypes[type]() || state;
}
